/**
 * The stored global messages types supported by this component.
 * @type {Object<String>}
 */
export const STORED_MESSAGES_TYPES = {
    COOKIE_APPROVAL: 'cookie_approval',
    TAX_FORM_NOTICE: 'tax_form_notice',
    IDENTITY_VERIFICATION: 'requires_identity_verification',
    REFERRAL_PROGRAM_INVITEE_DISCOUNT: 'rp_invitee_discount',
    CUSTOM_DISCOUNT_PROMO_CODE: 'custom_discount_promo_code',
    DISCOUNT_RANGES_PROMO_CODE: 'discount_ranges_promo_code'
};
